import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useRef } from "react";

Chart.register(...registerables);

const formatData = (data) => {
  const labels = [];
  const values = [];
  const leftLabels = [];
  const leftFullLabels = [];
  data?.forEach((item) => {
    labels.push(item.label);
    values.push(item.value);
    leftLabels.push(item.leftLabel);
    leftFullLabels.push(item.leftFullLabel);
  });
  return {
    labels,
    leftLabels,
    datasets: [
      {
        data: values,
        backgroundColor: "#6A30FE",
        barThickness: 10,
        datalabels: {
          display: false,
        },
        leftFullLabels,
        leftRawLabels: leftLabels,
      },
    ],
  };
};

const HorizontalNoGridBarChart = (props) => {
  const { data = [], id = "myChart", height = 400 } = props;

  const chartRef = useRef(null);

  useEffect(() => {
    const createChart = (chartData = []) => {
      const ctx = document.getElementById(id)?.getContext("2d");
      chartRef.current = new Chart(ctx, {
        type: "bar",
        data: chartData ?? [],
        plugins: [
          ChartDataLabels,
          {
            id: "floatingLabels",
            afterDatasetsDraw(chart) {
              const { ctx, chartArea } = chart;

              for (
                let i = 0;
                i < chart?.config?.data?.datasets?.[0]?.data?.length ?? 0;
                i++
              ) {
                const xPosition = chartArea?.left + 6;
                const yPosition = chart?.getDatasetMeta(0)?.data?.[i]?.y + 5;

                ctx.save();
                ctx.fillStyle = "#5F737F";
                ctx.font = "14px Inter";
                ctx.fillText(
                  chart?.config?.data?.leftLabels?.[i],
                  xPosition,
                  yPosition,
                );
              }
            },
          },
        ],
        options: {
          layout: {
            padding: {
              top: 20,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            bar: {
              borderRadius: 100,
              borderSkipped: false,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                title: (ctx) => {
                  const dataIdx = ctx?.[0]?.dataIndex;
                  return ctx?.[0]?.dataset?.leftFullLabels?.[dataIdx];
                },
                label: () => "",
              },
              axis: "y",
              intersect: false,
              filter: (ctx) => {
                const dataIdx = ctx?.dataIndex;
                const label = ctx?.dataset?.leftRawLabels?.[dataIdx];
                const ellipsisChar = label?.substr(
                  label?.length >= 3 ? label?.length - 3 : 0,
                  label?.length,
                );
                const isEllipsis = label?.length > 30 && ellipsisChar === "...";
                return isEllipsis;
              },
            },
          },
          scales: {
            y: {
              grid: { display: false },
              border: { display: false },
              position: "right",
              ticks: {
                display: true,
                color: "#1C1C1C",
                font: {
                  size: 14,
                },
                crossAlign: "far",
              },
            },
            x: {
              reverse: true,
              grid: { display: false },
              border: { display: false },
              ticks: { display: false },
              grace: "300%",
              min: 0,
            },
          },
          indexAxis: "y",
        },
      });
    };

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    createChart(formatData(data));

    return () => {
      chartRef.current.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, height]);

  return (
    <div className='w-full'>
      {Boolean(data?.length) ? (
        <canvas id={id} height={height}></canvas>
      ) : (
        <div className='flex justify-center items-center h-[400px]'>
          <img
            alt='horizontal-chart-empty-icon'
            src='/images/table-empty-state.svg'
            className='object-cover'
          />
        </div>
      )}
    </div>
  );
};

export default HorizontalNoGridBarChart;
